import './lib/lib';
import './base/base';
import './elements/elements';
import './modules/modules';

import './main.scss';

$(document).ready(() => {
  $('.js-carousel--rtl').slickSlider({
    slidesToShow: 5,
    slidesToScroll: 5,
    rtl: true,
  });
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/styleguide.js